import * as React from "react";
import { createRoot } from "react-dom/client";
import "../config/fonts";
import "../styles/index.css";
import App from "./App";
import Providers from "./Providers";
import { registerDiagnostics } from "../platform/shared/diagnostics";
import { getDocumentHostAdapter } from "../platform/documentHosts";

const rootElement: HTMLElement | null = document.getElementById("container");
const root = rootElement ? createRoot(rootElement) : undefined;

Office.onReady(() => {
  // `jyloDiag()` in the pane's console. Registered inside onReady because everything it
  // reads needs Office to have initialised.
  registerDiagnostics();

  // Resolved here, inside onReady, because Office.context.host is only reliable once
  // office.js has initialised. This entry serves Word, Excel and PowerPoint; Outlook
  // loads outlook.tsx instead and never reaches this.
  root?.render(
    <Providers adapter={getDocumentHostAdapter()}>
      <App />
    </Providers>
  );
});

if ((module as any).hot) {
  (module as any).hot.accept("./App", () => {
    const NextApp = require("./App").default;
    root?.render(NextApp);
  });
}
